<template>
    <div>
        <select class="form-select" v-model="selectedValue">
            <option :value="null">Typ pozemku</option>
            <option v-for="landType in landTypes" :key="landType.value" :value="landType.value">
                {{ capitalizeFirstLetter(landType.label) }}
            </option>
        </select>
    </div>
</template>

<script lang="ts">
import {defineComponent, PropType, ref, watch} from 'vue';

export interface LandTypeOption {
    readonly value: string;
    readonly label: string;
}

export default defineComponent({
    props: {
        landTypes: {
            type: Array as PropType<LandTypeOption[]>,
            required: true,
        },
    },
    emits: ['change'],
    setup(props, {emit}) {
        const selectedValue = ref<string | null>(null);

        watch(selectedValue, () => {
            emit('change', selectedValue.value);
        });

        function capitalizeFirstLetter(text: string): string {
            return text.charAt(0).toUpperCase() + text.slice(1);
        }

        return {selectedValue, capitalizeFirstLetter};
    },
});
</script>
